export const handleProgressive = (schema, EFFormData) => {
  const by = schema?.progressiveOrderSwitch?.by;
  if (!by?.level) return [];

  const startLevel = Number(by.level);
  const validSelectKeys = new Set(
    (schema?.fields || [])
      .filter((f) => f.type === "select" && f.optionsLevel !== false)
      .map((f) => f.key)
  );

  const result = Object.keys(EFFormData || {})
    .map(Number)
    .filter((lvl) => !isNaN(lvl) && lvl >= startLevel)
    .sort((a, b) => a - b)
    .flatMap((lvl) => {
      const arr = EFFormData[lvl];
      if (!Array.isArray(arr) || arr.length === 0) return [];

      return arr.flatMap((obj) => {
        if (!obj || typeof obj !== "object") return [];
        return Object.entries(obj)
          .filter(
            ([k, v]) =>
              validSelectKeys.has(k) &&
              v !== "" &&
              v !== null &&
              v !== undefined &&
              v !== "-"
          )
          .map(([k]) => k);
      });
    });

  return [...new Set(result)];
};
